var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventDispatcher } from "./lib/gate/EventDispatcher";
import { observable } from "mobx";
import store from "store";
import { get, pick, trim } from "lodash";
var Model = /** @class */ (function () {
    function Model(dataStore, gate) {
        this.dataStore = dataStore;
        this.gate = gate;
        this.dispatcher = new EventDispatcher();
        this.validateFunctions = {};
        this.errors = {};
        this.loading = false;
        this.isLoggedIn = false;
        this.isTableUserVisible = false;
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2 /*return*/];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.clearError = function (fieldId) {
        if (this.errors[fieldId]) {
            delete this.errors[fieldId];
            this.dispatcher.dispatch();
        }
    };
    Model.prototype.resolveActiveProfile = function (user) {
        var activeProfiles = (user.profiles || []).filter(function (p) { return !p.deletedAt; });
        var masterProfile = user.masterStudentProfileId &&
            activeProfiles.find(function (p) { return p.id === user.masterStudentProfileId; });
        return masterProfile || activeProfiles.find(function (p) { return p.isDefault; }) || activeProfiles[0];
    };
    Model.prototype.edularCoreSignIn = function (credentials) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var responseGate, user, profileId, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.gate.request("/signin", {
                                method: "POST",
                                data: {
                                    email: credentials.email,
                                    password: credentials.password
                                }
                            })];
                    case 1:
                        responseGate = _b.sent();
                        if (!responseGate.status) {
                            return [2 /*return*/];
                        }
                        user = responseGate.result.user;
                        profileId = (_a = this.resolveActiveProfile(user)) === null || _a === void 0 ? void 0 : _a.id;
                        this.gate.setToken(responseGate.result.token);
                        this.user = user;
                        this.token = responseGate.result.token;
                        this.profileId = profileId;
                        this.setStorage(user, responseGate.result.token, profileId);
                        this.dispatcher.dispatch();
                        return [2 /*return*/, responseGate];
                    case 2:
                        error_1 = _b.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Model.prototype.edularCoreSignInStudentStaff = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var responseGate, user, profile, profileId, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.gate.request("/signin-student-staff", {
                                method: "POST",
                                data: {
                                    email: credentials.email,
                                    password: credentials.password
                                }
                            })];
                    case 1:
                        responseGate = _a.sent();
                        if (!responseGate.status) {
                            return [2 /*return*/];
                        }
                        user = responseGate.result.user;
                        profile = this.resolveActiveProfile(user);
                        profileId = profile === null || profile === void 0 ? void 0 : profile.id;
                        this.gate.setToken(responseGate.result.token);
                        this.user = __assign(__assign({}, user), { profileType: profile === null || profile === void 0 ? void 0 : profile.type });
                        this.token = responseGate.result.token;
                        this.profileId = profileId;
                        this.setStorage(__assign(__assign({}, user), { profileType: profile === null || profile === void 0 ? void 0 : profile.type }), responseGate.result.token, profileId);
                        this.dispatcher.dispatch();
                        return [2 /*return*/, responseGate];
                    case 2:
                        error_2 = _a.sent();
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Model.prototype.loadSession = function () {
        var token = store.get("authToken");
        var user = store.get("user");
        var profileId = store.get("profileId");
        this.setUserToken(user, token, profileId);
    };
    Model.prototype.setUserToken = function (user, token, profileId) {
        if (user && token && profileId) {
            try {
                this.user = user;
                this.profileId = profileId;
                this.token = token;
                this.isLoggedIn = true;
                this.gate.setToken(token);
                this.gate.setProfileId(profileId);
            }
            catch (e) {
                store.remove("user");
            }
        }
    };
    Model.prototype.setStorage = function (user, token, profileId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    store.set("authToken", token);
                    this.gate.setProfileId(profileId);
                    this.gate.setToken(token);
                    store.set("profileId", profileId.toString());
                    store.set("user", user);
                    this.loadSession();
                    this.setUserStorage(user);
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    Model.prototype.setUserStorage = function (user) {
        var profiles = (user.profiles || []).map(function (_a) {
            var id = _a.id, isAccessDisabled = _a.isAccessDisabled, active = _a.active, type = _a.type, startDate = _a.startDate, contractEndDate = _a.contractEndDate, currentMajor = _a.currentMajor;
            return ({
                id: id,
                isAccessDisabled: isAccessDisabled,
                active: active,
                type: type,
                startDate: startDate,
                contractEndDate: contractEndDate,
                currentMajor: currentMajor
            });
        });
        var data = pick(user, [
            "id",
            "firstName",
            "lastName",
            "emails",
            "dateFormat",
            "masterStudentProfileId",
            "profileType"
        ]);
        data.profiles = profiles;
        store.set("user", data);
    };
    Model.prototype.logout = function () {
        store.clearAll();
        this.user = null;
        this.profileId = null;
        this.token = null;
        this.isLoggedIn = false;
        location.reload();
    };
    Model.prototype.searchStudent = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var responseGate, error_3, errorObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.gate.request("/search-user", {
                                method: "POST",
                                data: filter
                            })];
                    case 1:
                        responseGate = _a.sent();
                        if (!responseGate.status) {
                            return [2 /*return*/];
                        }
                        this.userList = responseGate.data;
                        this.isTableUserVisible = true;
                        this.dispatcher.dispatch();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        errorObject = get(error_3, "response.data", "");
                        throw errorObject;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Model.prototype.activateAccount = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var res, e_1, errorObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.gate.request("/activate-email-password", {
                                method: "POST",
                                data: data
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                    case 2:
                        e_1 = _a.sent();
                        errorObject = get(e_1, "response.data", "");
                        throw errorObject;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Model.prototype.signInOtp = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var responseGate, user, profile, e_2, errorObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.gate.request("/sign-in-otp", {
                                method: "POST",
                                data: data
                            })];
                    case 1:
                        responseGate = _a.sent();
                        if (!responseGate.status) {
                            return [2 /*return*/];
                        }
                        user = responseGate.result.user;
                        profile = responseGate.result.user.profiles[0];
                        this.gate.setToken(responseGate.result.token);
                        this.user = user;
                        this.token = responseGate.result.token;
                        this.profileId = profile.id;
                        this.setStorage(user, responseGate.result.token, profile.id);
                        this.dispatcher.dispatch();
                        return [2 /*return*/, responseGate];
                    case 2:
                        e_2 = _a.sent();
                        errorObject = get(e_2, "response.data", "");
                        throw errorObject;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Model.prototype.sendActivationOTP = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var email, data_1, response, error_4, errorObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = data.email;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        data_1 = {
                            email: trim(email),
                            type: "web-reset"
                        };
                        return [4 /*yield*/, this.getOtp(data_1)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_4 = _a.sent();
                        errorObject = get(error_4, "response.data", "");
                        if (errorObject.code === "invalid_password") {
                            throw "Incorrect email address or password";
                        }
                        else if (errorObject.code === "access_disabled") {
                            throw "Your access was temporarily disabled. Please, contact your school administrator to reinstate your access.";
                        }
                        else {
                            throw "Please check your email address.";
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Model.prototype.validateDefinedUserFields = function () {
        var result = true;
        var firstComponentWithError;
        var elements = document.getElementsByClassName(this.formUserCss);
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            if (element.id === undefined || element.id.trim().length === 0) {
                continue;
            }
            var value = this.json_data[element.id] || this.json_data[element.name] || "";
            if (element.className.indexOf("form-required") !== -1 &&
                !(value instanceof Date) &&
                (value === undefined || value.toString().trim().length === 0)) {
                this.errors[element.id] = "This field is required";
                result = false;
                if (firstComponentWithError === undefined) {
                    firstComponentWithError = element;
                }
            }
        }
        this.dispatcher.dispatch();
        if (firstComponentWithError) {
            firstComponentWithError.focus();
        }
        return result;
    };
    Model.prototype.validateFields = function () {
        var result = true;
        var firstComponentWithError;
        var elements = document.getElementsByClassName("form-required");
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            if (element.id === undefined || element.id.trim().length === 0) {
                continue;
            }
            var value = this.json_data[element.id] || this.json_data[element.name] || "";
            if (!(value instanceof Date) &&
                (value === undefined || value.toString().trim().length === 0)) {
                this.errors[element.id] = "This field is required";
                result = false;
                if (firstComponentWithError === undefined) {
                    firstComponentWithError = element;
                }
            }
        }
        this.dispatcher.dispatch();
        if (firstComponentWithError) {
            firstComponentWithError.focus();
        }
        return result;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                results = [];
                this.errors = {};
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false) || !this.validateDefinedUserFields()) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
            });
        });
    };
    Model.prototype.validateEditForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                results = [];
                this.errors = {};
                if (!this.validateFields()) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
            });
        });
    };
    Model.prototype.verifyEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gate.request("/verify-email")];
                    case 1:
                        response = _a.sent();
                        if (!response.success) {
                            throw new Error(response.errors[0].message);
                        }
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Model.prototype.getOtp = function (data, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gate.request("/get-one-time-password", {
                            method: "POST",
                            data: data,
                            params: params
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    __decorate([
        observable
    ], Model.prototype, "json_data", void 0);
    __decorate([
        observable
    ], Model.prototype, "user", void 0);
    __decorate([
        observable
    ], Model.prototype, "userList", void 0);
    __decorate([
        observable
    ], Model.prototype, "isLoggedIn", void 0);
    __decorate([
        observable
    ], Model.prototype, "isTableUserVisible", void 0);
    return Model;
}());
export { Model };
//# sourceMappingURL=data:application/json;base64,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